import { render, staticRenderFns } from "./myRecognitionsList.vue?vue&type=template&id=6be1b3da"
import script from "./myRecognitionsList.vue?vue&type=script&lang=js"
export * from "./myRecognitionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports